<!--登录-->
<template>
  <div class="login-container" v-loading="loading" :element-loading-text="loadingText"
       element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">
    <headerIndex/>
    <!--登录框-->
    <div class="login-menu">
      <div class="login-box">
        <el-row>
          <el-col :span="15" class="login-left">
            <el-tabs v-model="activeName">
              <el-tab-pane label="账号登录" name="password" class="pass">
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
                  <el-form-item prop="account">
                    <el-input v-model="ruleForm.account" maxlength="11" placeholder="手机号/邮箱" clearable></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="ruleForm.password" maxlength="16" type="password" placeholder="账户密码"
                              show-password></el-input>
                  </el-form-item>
                </el-form>
                <div class="u-flex u-row-between">
                  <el-checkbox v-model="automaticLogin">下次自动登录</el-checkbox>
                  <el-link :underline="false" class="forget-password" @click="forgotPwd">忘记密码?</el-link>
                </div>
              </el-tab-pane>
              <el-tab-pane label="短信登录" name="code" class="code">
                <el-form :model="shortForm" status-icon :rules="shortrules" ref="shortForm">
                  <el-form-item prop="mobile">
                    <el-input v-model="shortForm.mobile" maxlength="11" placeholder="手机号" clearable></el-input>
                  </el-form-item>
                  <el-form-item prop="code">
                    <el-input v-model="shortForm.code" maxlength="6" placeholder="验证码">
                      <template slot="suffix">
                        <el-link style="color: #1637FF;font-size: 14px;" @click="getMobileCode" :underline="false"
                                 v-if="timer==120">获取验证码
                        </el-link>
                        <el-link disabled v-else>{{ timer + 's后重试' }}</el-link>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="u-flex" style="padding-bottom: 20px;">
                  <span>阅读并接受</span>
                  <span><a class="bank-link" href="http://customerservice.bangqichat.com/index/agreement/article?aWQ9MjE="
                           target="_bank">《帮企网用户协议》</a></span>
                  <span>和</span>
                  <span><a class="bank-link" href="http://customerservice.bangqichat.com/index/agreement/article?aWQ9MjA="
                           target="_bank">《隐私政策》</a></span>
                </div>
              </el-tab-pane>
              <div style="padding:  0px 35px 0px 0px">
                <el-button type="primary" @click="login()">登录</el-button>
              </div>
            </el-tabs>
            <el-link type="primary" class="link-register SourceHanSansCN" :underline="false" @click="registerAccount">
              注册账号
            </el-link>
          </el-col>
          <el-col :span="9" class="scanning">
            <span class="SourceHanSansCN">扫码登录</span>
            <div class="qr-code">
              <el-image style="width: 180px; height: 180px" :src="codeImg"/>
            </div>
            <p class="scan-p">打开帮企网APP<br>扫描二维码登录</p>
          </el-col>
        </el-row>
      </div>
    </div>
    <footerIndex style="background: #ffffff"/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import {isMobile} from "@/common/tools"
import footerIndex from '@/components/footer/index'
import {getQrCode, pws, verifyMoblie,sms,pollingLoginState} from '@/api/loginApi'
import {sendsms,verifySms} from '@/api/currencyApi'
import $store from '@/store';

export default {
  name: "index",
  components: {headerIndex, footerIndex},
  data() {
    /*校验手机号*/
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的手机号码'));
      }
    }
    /*校验密码 密码由8-16位数字、字母下划线等组成*/
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      let regex = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)(?![_/*+~!@#、|":$%^&*(){}_+=;}{,./?]+$)[0-9A-Za-z_/*+~!@#、|":$%^&*(){}_+=;}{,./?]{8,16}$');
      if (regex.test(value)) {
        callback();
      } else {
        callback(new Error('密码由8-16位数字、字母下划线等组成'));
      }
    }
    return {
      activeName: 'password',
      /*密码登录*/
      ruleForm: {
        account: '',
        password: '',
      },
      /*密码登录校验*/
      rules: {
        account: [
          {validator: checkMobile, trigger: 'blur'}
        ],
        password: [
          {validator: checkPassword, trigger: 'blur'}
        ],
      },
      /*短信登录*/
      shortForm: {
        mobile: '',
        code: '',
      },
      /*短信登录校验*/
      shortrules: {
        mobile: [
          {validator: checkMobile, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      automaticLogin: false,
      timer: 120,
      isClickCode: false,
      codeImg: '',
      loadingText: '',
      loading: false,
      uuid:'',
      timers:null,
    }
  },
  methods: {
    /*跳转忘记密码页面*/
    forgotPwd() {
      this.$router.replace({
        path: '/ForgotPassword',
        query: {
          account: this.ruleForm.account
        }
      })
    },
    //登录
    login() {
      if (this.activeName == 'password') {
        //密码登录
        this.pwdLogin()
      } else {
        //验证码登录
        this.codeLogin();
      }
    },
    /*密码登录*/
    pwdLogin() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingText = '登录中...';
          let loginData = {mobile: this.ruleForm.account, pwd: this.ruleForm.password};
          pws(loginData).then(res => {
            if (res.code==200){
              this.loading = false;
              $store.state.hasLogin = true;
              $store.state.loginData = res.data;
              $store.state.token = res.data.token;
              $store.state.loginInfo = {mobile: this.ruleForm.account, pwd: this.ruleForm.password,activeName:'password'};
              sessionStorage.setItem("hasLogin", 'true');
              sessionStorage.setItem("token", res.data.token);
              localStorage.setItem("token", res.data.token);
              sessionStorage.setItem("loginData", JSON.stringify(res.data));
              this.$router.replace({
                path: '/'
              })
              this.$message.success('登录成功！');
            }else {
              this.loading = false;
              this.$message.error(res.esg);
              this.loadingText = '';
            }
          })
        } else {
          return false;
        }
      });
    },
    /*短信验证登录*/
    codeLogin() {
      this.$refs.shortForm.validate((valid) => {
        if (valid) {
          /* 验证短信接口 */
          this.loading = true;
          this.loadingText = '登录中...';
          verifySms({smscode: this.shortForm.code, uuid: this.shortForm.mobile}).then(res=>{
            if (res.code==200){
              /*短信登录*/
              sms({mobile:this.shortForm.mobile}).then(res=>{
                if (res.code==200){
                  this.loading = false;
                  $store.state.hasLogin = true;
                  $store.state.loginData = res.data;
                  $store.state.token = res.data.token;
                  $store.state.loginInfo = {smscode: this.shortForm.code, uuid: this.shortForm.mobile,activeName:'code'};
                  sessionStorage.setItem("hasLogin", 'true');
                  sessionStorage.setItem("token", res.data.token);
                  localStorage.setItem("token", res.data.token);
                  sessionStorage.setItem("loginData", JSON.stringify(res.data));
                  this.$router.replace({
                    path: '/'
                  })
                  this.$message.success('登录成功！');
                }
              })
            }
          })
        } else {
          return false;
        }
      })
    },
    //获取手机验证码
    getMobileCode() {
      if (this.timer < 120) {
        return
      }
      if (this.isClickCode) {
        return
      }
      /*校验手机号*/
      if (!isMobile(this.shortForm.mobile)) {
        this.$message.error('请输入手机号')
        return
      }
      this.isClickCode = true;
      setTimeout(() => {
        this.isClickCode = false;
      }, 1000);
      this.loading = true;
      this.loadingText = '请稍后...';
      verifyMoblie({moblie: this.shortForm.mobile}).then(res => {
        this.loading = false;
        if (res.code == '201') {
          sendsms({mobile: this.shortForm.mobile, uuid: '', name: "验证码登录"}).then(res => {
            this.$message.success('验证码已发送')
            let timer = setInterval(() => {
              if (this.timer <= 0) {
                clearInterval(timer);
                this.timer = 120;
                return
              } else {
                this.timer--
              }
            }, 1000)
          })
        } else {
          this.$message.error('手机号未注册')
        }
      }).catch(err => {
        loading.close()
      })
    },
    /*跳转注册页面*/
    registerAccount() {
      this.$router.replace({
        path: '/register'
      })
    },
    /*获取登录二维码*/
    getCode() {
      getQrCode().then(res => {
        if (res.code==200){
          this.codeImg = res.data.image;
          this.uuid=res.data.uuid;
        }
      })
    },
    /*查询二维码登录状态*/
    monitorLogin(){
      pollingLoginState({uuid:this.uuid.replace('||帮企网', ''),request:'form'}).then(res=>{
        if (res.code==200){
          $store.state.hasLogin = true;
          $store.state.loginData = res.data;
          $store.state.token = res.data.token;
          $store.state.loginInfo = {uuid: this.uuid,activeName:'qr'};
          sessionStorage.setItem("hasLogin", 'true');
          sessionStorage.setItem("token", res.data.token);
          localStorage.setItem("token", res.data.token);
          sessionStorage.setItem("loginData", JSON.stringify(res.data));
          this.$router.replace({
            path: '/'
          })
          this.$message.success('登录成功！');
        }
      })
    },
  },
  mounted() {
    this.getCode();
    this.timers = setInterval(() => {
      setTimeout(this.monitorLogin, 0);
    }, 1000);
    if (this.$route.query.mobile!='' && this.$route.query.mobile!=undefined && this.$route.query.mobile!=null)
      this.ruleForm.account=this.$route.query.mobile;
  },
  created() {
    // 实现轮询
    window.setInterval(() => {
      setTimeout(this.getCode, 0);
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.timers);
    this.timers = null;
  },
}
</script>
<style scoped>
.login-container >>> .el-tabs__item {
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  font-family: 'SourceHanSansCN';
}

.login-container >>> .el-tabs__item.is-active {
  color: #333333;
  font-family: 'SourceHanSansCN';
}

.login-container >>> .el-tabs__active-bar {
  height: 0px;
  background-color: white;
}

.login-container >>> .el-tabs__nav-wrap::after {
  height: 2px;
  background-color: #ffffff;
  z-index: 1;
}

.login-container >>> .el-input__inner {
  background-color: #F1F1F1;
  border-radius: 8px;
  border: 1px solid #F1F1F1;
  color: #333333;
  font-size: 14px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
}

.login-container >>> input::-webkit-input-placeholder {
  color: #999999;
}

.login-container >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1637FF;
  border-color: #1637FF;
}

.login-container >>> .el-checkbox {
  color: #333333;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
  font-size: 14px;
}

.login-container >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333333;
  font-weight: 500;
}

.login-container >>> .el-link.el-link--default :hover {
  color: #1637FF;
}

.login-container >>> .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
  width: 100%;
  height: 55px;
}

.login-container >>> .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.login-container >>> input:-internal-autofill-selected {
  background-color: #F1F1F1 !important;
}
</style>
<style scoped lang="scss">
.login-container {
  background: url("~@/assets/img/denglu.png") no-repeat;
  height: -webkit-fill-available;
  width: -webkit-fill-available;
  position: fixed;
  background-size: cover;
  .login-menu{
    display: flex;
    justify-content: right;
    align-items: center;
    margin-right: 15%;
    height: inherit;
    margin-bottom: 10%;
    .login-box {
      background: #fff;
      border-radius: 20px;
      padding: 30px 40px 40px;
      width: 580px;
      .scanning {
        text-align: center;
        padding: 10px 0px;

        .qr-code {
          margin: 25px;
          height: 180px;
          width: 180px;
          padding: 10px;
          background: #F1F3FB;
          cursor: pointer;
        }

        .scan-p {
          font-weight: 500;
          color: #333333;
          letter-spacing: 1px;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          line-height: 25px;
        }
      }

      .login-left {
        border-right: 1px solid #EEEEEE;

        .link-register {
          position: absolute;
          top: 8px;
          font-size: 16px;
          right: 43%;
          color: #1637FF;
          font-weight: 100;
        }

        .pass {
          padding: 10px 35px 30px 0px;

          .forget-password {
            float: right;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
        }

        .code {
          padding: 10px 35px 10px 0px;
          span{
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
          .bank-link {
            text-decoration: none;
            color: rgb(22, 55, 255);
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
        }
      }
    }
  }
}
</style>